module.exports = __webpack_public_path__ + "assets/31503ff7f46514d86349d3cecda866a2.woff2";